export type QueryParams = Record<string, string>;
export const queryParams: QueryParams = Object.fromEntries(
  window.location.search
    .replace("?", "")
    .split("&")
    .filter(Boolean)
    .map((kv) => kv.split("="))
);
